// These constants represent the different types of permutations of
// CTA Prompts laid out as the 3 main registration/action buttons
// for our clients vertically

export const ACT_NOW = 'CTAPromptTypes.ACT_NOW'
export const WHATS_NEXT = 'CTAPromptTypes.WHATS_NEXT'

export default {
    ACT_NOW,
    WHATS_NEXT,
}
